import { MessengerPositionEnum, OldMessengerPosition } from "../enums";

export const mapMessengerPosition: any = {
    [OldMessengerPosition.messenger_home]: MessengerPositionEnum.MESSENGER_HOME,
    [OldMessengerPosition.story]: MessengerPositionEnum.STORY,
    [OldMessengerPosition.sponsored_messages]: MessengerPositionEnum.SPONSORED_MESSAGES
}